var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 23,
  viewBox: "0 0 23 23"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1h1v22H0zM22 1h1v22h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 22h23v1H0zM11 1h1v16h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.268 11 .707.706-4.95 4.95-.707-.707z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.732 11-.707.707 4.95 4.95.706-.707zM0 0h23v1H0z"
}))));
export default SvgDownload;